import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { checkAccessToken } from '@/utils/handle-authentication';
import { getListEmployeeInsideAction } from '@/redux/actions/employee';
import { getListEmployeeInside, TGetListEmployeeInsideResponse } from '@/services/api/employee';
import { handleAPIError } from '@/utils/handle-api-error';

// FUNCTION
export function* getListEmployeeInsideSaga(action: ActionType<typeof getListEmployeeInsideAction.request>): Generator {
  const { companyId, projectId, successCallback, failedCallback } = action.payload;
  try {
    yield call(checkAccessToken);
    const response = yield call(getListEmployeeInside, companyId, projectId);
    const getListEmployeeInsideResponse: TGetListEmployeeInsideResponse = response as TGetListEmployeeInsideResponse;
    yield put(getListEmployeeInsideAction.success(getListEmployeeInsideResponse));
    successCallback?.(getListEmployeeInsideResponse);
  } catch (err) {
    handleAPIError(err, 'Error.getListEmployeeInsideProjectError');
    yield put(getListEmployeeInsideAction.failure(err));
    failedCallback?.(err);
  }
}
